import store from '@shared/store/index';

export const callOverlay = ({ text, color, icon }) => {
  store.dispatch('OverlayManager/addMessage', {
    text,
    color,
    icon
  });
};